export const vehicles = [
  {
    id: 1,
    year: 2021,
    make: 'Ford',
    model: 'F-150',
    trim: 'Lariat 502A',
    price: 54900,
    msrp: 58500,
    mileage: 42000,
    mpg: '18/23',
    engine: '3.5L V6 EcoBoost',
    transmission: '10-Speed Automatic',
    image: 'https://images.unsplash.com/photo-1605893477799-b99e3b8b93fe?w=500&h=300&fit=crop',
    special: 'Local Trade-In',
    type: 'Truck'
  },
  {
    id: 2,
    year: 2022,
    make: 'Honda',
    model: 'Civic',
    trim: 'Touring',
    price: 31500,
    msrp: 33000,
    mileage: 15600,
    mpg: '31/38',
    engine: '1.5L Turbo 4-Cyl',
    transmission: 'CVT',
    image: 'https://images.unsplash.com/photo-1605816288393-2e1af93c6c8a?w=500&h=300&fit=crop',
    special: 'Fuel Efficient',
    type: 'Sedan'
  },
  {
    id: 3,
    year: 2020,
    make: 'Toyota',
    model: 'RAV4',
    trim: 'XLE Premium',
    price: 34900,
    msrp: 36500,
    mileage: 58000,
    mpg: '27/33',
    engine: '2.5L 4-Cyl',
    transmission: '8-Speed Automatic',
    image: 'https://images.unsplash.com/photo-1594502184342-2e12f877aa73?w=500&h=300&fit=crop',
    special: 'Certified Used',
    type: 'SUV'
  },
  {
    id: 4,
    year: 2023,
    make: 'BMW',
    model: 'X5',
    trim: 'xDrive40i',
    price: 78900,
    msrp: 82000,
    mileage: 8500,
    mpg: '21/25',
    engine: '3.0L I6 Turbo',
    transmission: '8-Speed Sport Automatic',
    image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=500&h=300&fit=crop',
    special: 'Executive Demo',
    type: 'SUV'
  },
  {
    id: 5,
    year: 2019,
    make: 'GMC',
    model: 'Sierra 1500',
    trim: 'Denali',
    price: 49500,
    msrp: 52000,
    mileage: 88000,
    mpg: '15/20',
    engine: '6.2L V8',
    transmission: '10-Speed Automatic',
    image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500&h=300&fit=crop',
    type: 'Truck'
  },
  {
    id: 6,
    year: 2021,
    make: 'Tesla',
    model: 'Model 3',
    trim: 'Long Range',
    price: 45900,
    msrp: 49000,
    mileage: 32000,
    mpg: '134 MPGe',
    engine: 'Dual Motor Electric',
    transmission: 'Single-Speed',
    image: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=500&h=300&fit=crop',
    special: 'Electric Special',
    type: 'Sedan'
  }
];

export const getVehiclesByFilter = (filters) => {
  let filtered = [...vehicles];
  
  if (filters.make) {
    filtered = filtered.filter(v => 
      v.make.toLowerCase().includes(filters.make.toLowerCase())
    );
  }

  if (filters.model) {
    filtered = filtered.filter(v => 
      v.model.toLowerCase().includes(filters.model.toLowerCase())
    );
  }

  if (filters.maxPrice) {
    filtered = filtered.filter(v => v.price <= filters.maxPrice);
  }

  if (filters.type) {
    filtered = filtered.filter(v => 
      v.type.toLowerCase() === filters.type.toLowerCase()
    );
  }

  return filtered;
};